
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DialogBanner extends Vue {
  @Prop({ default: "" })
  title!: string;

  @Prop({ default: true })
  hideActions!: boolean;

  @Prop({ default: false })
  tabs!: boolean;

  @Prop({ default: 0 })
  value!: number;

  @Prop({ default: false })
  hideBackArrow!: boolean;

  @Prop({ default: false })
  onlyTitle!: boolean;

  get selectedTab() {
    return this.value;
  }

  set selectedTab(newVal) {
    this.$emit("input", newVal);
  }

  goBack() {
    this.$emit("back-arrow");
  }
}
